export default __webpack_public_path__ + "f2a3b929d3df9283e06ec8dfbeddbe0f.png";